import { useState } from "react";
import { LuPlus } from "react-icons/lu";
import { useSelector } from "react-redux";
import * as styled from "./AddWordForm.styled"
import { langOf } from "../../helpers/langs";

function AddWordForm({onAdd}){
  const [word, setWord] = useState("");
  const [translation, setTranslation] = useState("");
  const accessType = useSelector((state) => state.auth?.data?.accessType);

  const handleSubmit = e => {
    e.preventDefault();
    if (word && translation) {
      onAdd({ word, translation });
      setWord("");
      setTranslation("");
    }
  };

  return (
    <styled.FormWrapper onSubmit={handleSubmit}>
      <styled.Input
        placeholder={`Слово ${langOf(accessType)?.word || "англійською"}`}
        value={word}
        onChange={e => setWord(e.target.value)}
      />
      <styled.Input
        placeholder="Переклад"
        value={translation}
        onChange={e => setTranslation(e.target.value)}
      />
      <styled.Button type="submit">
        <LuPlus size={18} /> Додати
      </styled.Button>
    </styled.FormWrapper>
  );
};

export default AddWordForm;
